import React from "react";
import { PayPalButtons, PayPalScriptProvider } from "@paypal/react-paypal-js";

export default function PayPalPayment({ amount, onSuccess, onError }) {
  const clientId = "AWTotZqnpHh207h5zOjulLn4H3mrHeKyntVLX2xH9QGD_BjDG-L740uzxE_0vdxnjn6ZNz39ejZJQ_0p";

  return (
    <PayPalScriptProvider
      options={{
        "client-id": clientId,
        currency: "USD",
        locale: "en_US",
      }}
    >
      <PayPalButtons
        style={{
          layout: "vertical",
          color: "gold",
          shape: "rect",
          label: "pay",
        }}

        //🚀 CREATE ORDER (FONCTIONNE VRAIMENT)
        createOrder={(data, actions) => {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: amount.toFixed(2), // USD
                },
              },
            ],
          });
        }}

        //🚀 CAPTURE ORDER
        onApprove={(data, actions) => {
          return actions.order
            .capture()
            .then((details) => onSuccess(details))
            .catch(() => onError("PayPal payment failed"));
        }}

        onError={(err) => onError("PayPal error")}
      />
    </PayPalScriptProvider>
  );
}
